import { ChangeEvent, useEffect, useState } from "react";
import useFirestore from "shared/hooks/useFirestore";
import { OrderByDirection, WhereFilterOp } from "firebase/firestore";
import styled from "styled-components";

interface sort{
    name:string,
    direction:OrderByDirection,
}

const useBranchListView = () => {
    const uid = sessionStorage.getItem("uid") || "";
    const { readFirestore} = useFirestore();
    const [search, setSearch] = useState<string>('');
    const [lists, setLists] = useState<any[]>([]);
    const [searchedLists, setSearchedLists] = useState<any[]>([]);
    useEffect(() => {
        getList();
        // eslint-disable-next-line
    }, [])

    const onChange = (e:ChangeEvent<HTMLInputElement>) => {
        setSearch(e.target.value);
    }

    const onRefreshClick = () => {
       getList();
    }

    const getList = async() => {
        setLists([]);
        setSearchedLists([]);
        readFirestore("User/Auth/Branch").then(res => {
            res.forEach((doc:any) => {
                setLists(item => [...item, {id:doc.id, name:doc.data().name}]);
                setSearchedLists(item => [...item, {id:doc.id, name:doc.data().name}]);
            })
        })
    }

    useEffect(() => {
        const searchedItems = lists.filter((item) => item["name"].includes(search));
        setSearchedLists(searchedItems);
        // eslint-disable-next-line
    }, [search])


    return {search, searchedLists, onChange, onRefreshClick}

}

export default  useBranchListView;